<template>
    <tr :class="printable ? '' : color">
        <th :colspan="qtcolunas">
            <template v-if="!printable">
                <a href="#" @click.prevent="addFiltroByGroup(relatorio.result.group_cols[nivel])" class="card-link text-dark" 
                    :class="'ml-' + ( nivel * 2 )" :style="printableFont">
                    {{ info_quebra }} {{ get_outros_campos() }}
                </a>
            </template>
            <template v-else>
                <span :class="'ml-' + ( nivel * 2 )" :style="printableFont">
                    {{ info_quebra }} {{ get_outros_campos() }}
                </span>
            </template>
        </th>
    </tr>
</template>

<script>
import _ from 'lodash';
import * as moment from "moment";

export default {
    props: ['relatorio', 'printableFont', 'quebra', 'addFiltroByGroup', 'nivel', 'dadosgrupo', 'printable' ],

    computed: { 
        info_quebra: function () { 
            if ( this.quebra && this.quebra.length == 10 ) { 
                if ( this.quebra.match(/^\d{4}-\d{2}-\d{2}$/) ) { 
                    return moment(this.quebra).format('DD/MM/YYYY');
                }
            }

            return this.quebra;
        },

        color: function () { 
            switch (this.nivel) {
                case 0: return 'table-primary';
                case 1: return 'table-info';
                case 2: return 'table-secondary';
                default: return 'table-secondary';
            }
        },

        qtcolunas: function() { 
            /*
            if ( this.relatorio.pivot_col ) { 
                return this.relatorio.result.columns.filter(item => !( item.pivot || item.type == 'value' )).length
                    + this.$parent.listar({ name: this.relatorio.pivot_col.column_name }).length
                    + 1;
            }
            */

            return this.relatorio.result.columns.length
                + this.relatorio.result.columns.filter(item => item.percent).length;

        }
    },

    methods: {
        get_outros_campos() { 
            let secs = _.get(this.relatorio, 'result.group_cols.' + this.nivel + '.sec', []); 
            if ( secs ) { 

                let dados = _.cloneDeep(this.dadosgrupo);
                let cont = 0; 

                do {
                    if ( _.get(dados, '0') ) { 
                        break;
                    }
                        
                    dados = _.first(_.values(dados));

                    cont ++;
                } while ( cont < 10 );

                return _.reduce(secs, (acc, sec) => { 
                    const dado = _.get(dados, '0.' + _.get(sec, 'name'), '');
                    return acc + ' / ' + dado;
                }, '');

            }
        },
    }
}
</script>